import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Sprout } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); setSent(true); toast.success("Instruksi dikirim"); }
    catch (e) { setErr(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-6">
          <Sprout className="w-6 h-6 text-emerald-800"/>
          <span className="font-bold text-xl" style={{fontFamily:"Outfit"}}>SatuCRM</span>
        </div>
        <h1 className="text-2xl font-bold mb-2">Lupa password?</h1>
        <p className="text-sm text-slate-500 mb-6">Kami akan mengirim tautan reset ke email Anda.</p>
        {sent ? (
          <div className="rounded-lg bg-emerald-50 border border-emerald-200 p-4 text-sm text-emerald-800">
            Jika email terdaftar, tautan reset telah dikirim.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5"><Label>Email</Label><Input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}/></div>
            {err && <div className="text-sm text-rose-600">{err}</div>}
            <Button type="submit" className="brand-btn w-full h-11">Kirim tautan reset</Button>
          </form>
        )}
        <p className="text-sm text-slate-500 mt-6 text-center">
          <Link to="/login" className="text-emerald-800 hover:underline">Kembali ke login</Link>
        </p>
      </div>
    </div>
  );
}
